import React from "react";
import InputDate from "../../../../../components/ui/InputDate/InputDate";
import { Dropdown } from "../../../../../components/ui/Dropdown/Dropdown";
import Button from "../../../../../components/ui/Button/Button";
import ReturnAndRefundInformationTable from "../../OrderStatus/Section/ReturnAndRefundInformationTable";
import { useProductOrderStatuses } from "../../../../../api/order-management/use-order-status";

const options = [
  { id: 1, name: "상품명" },
  { id: 2, name: "주문번호" },
  { id: 3, name: "주문자(담당자)" },
];

const radioOptions = ["전체", "반품요청", "반품승인", "반품거부(구매확정)"];

const radioOptions2 = [
  "반품배송(반송)",
  "반품완료(신용카드)",
  "반품완료(무통장입금)",
];

const OrderReturnedInfo = (props) => {
  const {
    returnRefundData,
    tableHead1 = (
      <div>
        반품완료
        <br />
        (미입금)
      </div>
    ),
    tableHead2 = (
      <div>
        반품취소
        <br />
        (무통장입금)
      </div>
    ),
    tableHead3 = (
      <div>
        반품거부
        <br />
        (구매확정)
      </div>
    ),
  } = props;

  return (
    <div className="mb-4">
      <div className="-mt-4 ">
        <h1 className="bg-primary-blue text-white px-4 font-bold py-2.5">
          반품 정보
        </h1>
        <div className="flex w-full">
          <div className="flex w-full">
            <div className="border w-40 text-center py-5 border-primary-grey font-bold border-t-0 bg-input-grey">
              {tableHead1}
            </div>
            <div className="grid w-full">
              <input
                type="text"
                placeholder="0건"
                className="placeholder:text-black w-full placeholder:font-bold border-r-0 outline-none border border-l-0 px-2"
              />
              <input
                type="text"
                placeholder="0원"
                className="border placeholder:text-black border-l-0 outline-none w-full border-r-0 border-t-0 px-2"
              />
            </div>
          </div>
          <div className="flex w-full">
            <div className="border w-40 text-center py-5 border-primary-grey font-bold border-t-0 bg-input-grey">
              {tableHead2}
            </div>
            <div className="grid w-full">
              <input
                type="text"
                placeholder="0건"
                className="placeholder:text-black border-r-0 placeholder:font-bold outline-none border border-l-0 px-2"
              />
              <input
                type="text"
                placeholder="0원"
                className="border placeholder:text-black border-l-0 outline-none border-r-0 border-t-0 px-2"
              />
            </div>
          </div>
          <div className="flex w-full">
            <div className="border w-40 text-center py-5 border-primary-grey font-bold border-t-0 bg-input-grey">
              {tableHead3}
            </div>
            <div className="grid w-full">
              <input
                type="text"
                placeholder="0건"
                className="placeholder:text-black outline-none placeholder:font-bold border border-l-0 px-2"
              />
              <input
                type="text"
                placeholder="0원"
                className="border placeholder:text-black border-l-0 outline-none border-t-0 px-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex gap-6 mt-6">
        <div className="w-[50%]">
          <ReturnAndRefundInformationTable data={returnRefundData} />
        </div>
        <div className="w-[50%] py-4 bg-input-grey">
          <div className="flex px-4 space-x-4">
            <p className="w-14 font-bold">주문구분</p>
            <div className="flex items-center">
              <input
                type="radio"
                name="orderClassification"
                className="accent-black mr-2"
              />
              <span>전체</span>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="orderClassification"
                className="accent-black mr-2"
              />
              <span>자동(재고)</span>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="orderClassification"
                className="accent-black mr-2"
              />
              <span>수동(재고)</span>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="orderClassification"
                className="accent-black mr-2"
              />
              <span>수동(원데이몰)</span>
            </div>
          </div>
          <div className="flex px-4 mt-2">
            <p className="w-14 font-bold mr-4">상태</p>
            <div>
              <div className="flex space-x-4">
                {radioOptions.map((item) => (
                  <div key={item} className="flex items-center">
                    <input
                      type="radio"
                      name="state"
                      className="accent-black mr-2"
                    />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="flex mt-2 space-x-4">
                {radioOptions2.map((item) => (
                  <div className="flex items-center">
                    <input
                      type="radio"
                      name="state"
                      className="accent-black mr-2"
                    />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex space-x-2 px-4 items-center mt-2">
            <p className="w-16 font-bold">기간</p>
            <InputDate />
            <span className="text-disable-black">-</span>
            <InputDate />
          </div>
          <div className="flex space-x-2 px-4 items-center mt-2">
            <p className="w-16 font-bold">검색어</p>
            <Dropdown
              options={options}
              textColor="black"
              placeholder="상품명"
              backgroundDropdown={`bg-white`}
              positionDropdown="top-10"
              width="w-40"
            />
            <input
              type="text"
              placeholder="검색"
              className="h-8 px-2 w-60 rounded-[4px]"
            />
          </div>
          <div className="border-t-disable-grey flex justify-center mt-3 pt-3 border-t">
            <Button
              text="필터 검색"
              paddingButton="py-1"
              borderColor="border border-secondary-grey"
            />
            <Button
              text="필터 초기화"
              paddingButton="py-1"
              borderColor="border border-secondary-grey"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderReturnedInfo;
